const hydrateChemicalNupointIds = (selectedChemicals = [], chemicals = []) =>
  selectedChemicals.map((chemical) => {
    const matchedChemical = chemicals.find(
      (candidate) => candidate.chemicalName === chemical.chemicalName
    );

    return {
      ...chemical,
      nupointID: chemical.nupointID ?? matchedChemical?.nupointID ?? "",
    };
  });

export default hydrateChemicalNupointIds;
